module.exports = __webpack_public_path__ + "dollar.9862e8d.png";